import React, { useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal'; 
import "react-responsive-modal/styles.css"; 
import { useDispatch, useSelector } from "react-redux";
import {
  requestLoginOtp,
  validateOtpLogin,
  closeLoginModal,
} from "../../slices/authSlice";
import { toast } from "react-toastify";
import { fetchCartFromServer } from "../../slices/cart";
const OtpInputs = ({ value, onChange, length = 6 }) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const digit = e.target.value.replace(/\D/g, "");
    if (!digit) return;

    const newOtp = value.split("");
    newOtp[index] = digit;
    onChange(newOtp.join(""));

    if (index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = value.split("");
      newOtp[index] = "";
      onChange(newOtp.join(""));

      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length);

    if (pasted.length === length) {
      onChange(pasted);
      inputRefs.current[length - 1]?.focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
      {[...Array(length)].map((_, i) => (
        <input
          key={i}
          ref={(el) => (inputRefs.current[i] = el)}
          type="tel"
          maxLength="1"
          value={value[i] || ""}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          onPaste={handlePaste}
          style={{
            width: "48px",
            height: "48px",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "bold",
            border: "1px solid #ccc",
            borderRadius: "6px",
            outline: "none",
          }}
        />
      ))}
    </div>
  );
};

// --- END: Custom OTP Input Component ---


export default function LoginModal() {
  const dispatch = useDispatch();
  const { showLoginModal, otpSent, status, error } = useSelector((s) => s.auth);

  const [mobileNumber, setMobileNumber] = useState(""); 
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  const showToast = (title, status) => {
    if (status === "error") {
      toast.error(title);
    } else {
      toast.success(title);
    }
  };

  const handleSendOtp = async () => {
    
    const res = await dispatch(requestLoginOtp(mobileNumber)); 

    if (requestLoginOtp.fulfilled.match(res)) {
      showToast("OTP sent successfully!", "success");
      setResendTimer(30); 
    } else {
      showToast(res.payload || "Failed to send OTP", "error");
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return showToast("Enter the 4-digit OTP", "error");
    
    const res = await dispatch(validateOtpLogin({ mobile: mobileNumber, otp })); 

    if (validateOtpLogin.fulfilled.match(res)) {
      showToast("Login successful!", "success");
      dispatch(closeLoginModal());
      dispatch(fetchCartFromServer());
      window.location.reload();
    } else {
      showToast(res.payload || "Invalid OTP", "error");
    }
  };

  useEffect(() => {
    let timer;
    if (otpSent && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } 
    return () => clearInterval(timer);
  }, [otpSent, resendTimer]);

  const onCloseModal = () => dispatch(closeLoginModal());

  const modalStyles = {
    modal: {
      maxWidth: '700px', 
      width: '90%',
      padding: '0', 
      borderRadius: '12px',
      overflow: 'hidden',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
    closeButton: {
        display: 'none', 
    }
  };

  return (
    <Modal
      open={showLoginModal}
      onClose={onCloseModal}
      center
      showCloseIcon={false} 
      styles={modalStyles}
    >
      <div style={{ display: 'flex' }}>
        
        <div
          style={{
            width: '50%',
            backgroundColor: '#FFE4E1', 
            padding: '32px',
            display: window.innerWidth > 768 ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
           <img src={require("../../assets/Images/AeliteZLogoWriteRed.gif")} alt="logo" style={{width:"40px",height:"30px"}} />
                                            <img src={require("../../assets/Images/Logoname.png")} alt="logo" style={{width:"100px",height:"20px",marginTop:"3px"}} />
        </div>

        <div
          style={{
            width: window.innerWidth > 768 ? '50%' : '100%',
            padding: '24px 24px 32px 24px',
            position: 'relative',
            backgroundColor: 'white',
          }}
        >
          
          <button
            onClick={onCloseModal}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#333',
              padding: '4px',
              lineHeight: '1',
            }}
            aria-label="Close modal"
          >
            &times;
          </button>

          <div 
            style={{ 
              textAlign: 'center', 
              fontSize: '20px', 
              fontWeight: 'bold', 
              marginBottom: '24px' 
            }}
          >
            {otpSent ? "OTP Verification" : "Enter your Mobile Number"}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {!otpSent ? (
              <>
                <div style={{ display: 'flex', border: '1px solid #ccc', borderRadius: '4px' }}>
                 
                  <input
                    type="tel"
                    placeholder="Enter your Mobile Number"
                    value={mobileNumber}
                    required
                    onChange={(e) => setMobileNumber(e.target.value)}
                    style={{
                      flex: 1,
                      padding: '8px 12px',
                      border: 'none',
                      outline: 'none',
                      fontSize: '16px',
                    }}
                  />
                </div>
                
                <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#333' }}>
                  <input type="checkbox" defaultChecked style={{ marginRight: '8px', accentColor: 'var(--cr-red-logo)' }} />
                  Notify me for any updates & offers
                </label>
              </>
            ) : (
              <>
                <div style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
                  We have sent verification code to
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                  <div style={{ fontWeight: 'bold' }}>{mobileNumber}</div>
                  <button 
                    onClick={onCloseModal} 
                    style={{ 
                      color: 'blue', 
                      fontSize: '14px', 
                      background: 'none', 
                      border: 'none', 
                      cursor: 'pointer', 
                      textDecoration: 'underline' 
                    }} 
                  >
                    Edit
                  </button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
                  <OtpInputs value={otp} onChange={setOtp} length={6} />
                </div>

                <div style={{ textAlign: 'center', fontSize: '14px', marginTop: '8px', color: '#666' }}>
                  {resendTimer > 0 ? (
                    <span>Resend OTP in <span style={{ fontWeight: 'bold' }}>{resendTimer}</span> Sec</span>
                  ) : (
                    <button 
                      onClick={handleSendOtp} 
                      disabled={status === "loading"}
                      style={{ 
                        color: 'var(--cr-red-logo)', 
                        fontWeight: '600', 
                        background: 'none', 
                        border: 'none', 
                        cursor: 'pointer',
                        opacity: status === "loading" ? 0.5 : 1,
                      }}
                    >
                      Resend OTP
                    </button>
                  )}
                </div>
              </>
            )}
            {error && <div style={{ color: 'red', textAlign: 'center', fontSize: '14px' }}>{error}</div>}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '24px' }}>
            <button
              onClick={!otpSent ? handleSendOtp : handleVerifyOtp}
              disabled={ (otpSent && otp.length !== 6)}
              style={{
                backgroundColor: 'var(--cr-red-logo)', 
                color: 'white',
                border: 'none',
                padding: '12px 0',
                fontSize: '18px',
                fontWeight: '600',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                opacity: ( (otpSent && otp.length !== 6)) ? 0.6 : 1,
              }}
            >
              {(!otpSent ? "Send OTP" : "Verify")}
            </button>
            
           
            
            <div style={{ fontSize: '12px', color: '#666', textAlign: 'center', marginTop: '0' }}>
              I accept that I have read & understood AeliteZ's{" "}
              <a href="#" style={{ color: 'blue', textDecoration: 'underline' }}>Privacy Policy</a> and{" "}
              <a href="#" style={{ color: 'blue', textDecoration: 'underline' }}>T&Cs</a>.
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}